module.exports = __webpack_public_path__ + "fonts/VISBYROUNDCF-REGULAR.15ca16e3.OTF";